import { Component, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PulseSurveyService } from "src/app/shared/services/legacy/pulse-survey.service";
import { CollapseComponent } from "../../../shared/components/collapse/collapse.component";
import { ImagePipe } from "../../../shared/pipes/image/image.pipe";

@Component({
	selector: "app-pulse-survey-introduction",
	imports: [TranslateModule, CollapseComponent, RouterLink, ImagePipe],
	templateUrl: "./pulse-survey-introduction.component.html",
	styleUrl: "./pulse-survey-introduction.component.scss",
})
export class PulseSurveyIntroductionComponent {
	readonly #route = inject(ActivatedRoute);
	readonly #pulseSurveyService = inject(PulseSurveyService);

	readonly #surveyId = signal(this.#route.snapshot.params["surveyId"]);

	public readonly pulseSurvey = toSignal(
		this.#pulseSurveyService.getPulseSurvey(this.#surveyId()),
	);

	public consentValue = signal(false);

	public onConsentChange(event: Event): void {
		const checked = (event.target as HTMLInputElement)?.checked ?? false;
		this.consentValue.set(checked);
	}
}
